<template>
  <a-row :gutter="16">
    <a-col :span="showSpan?showSpan:6"
           :key="homeShowIndex"
           v-if="homeShowIndex<8"
           v-for="(homeShowItem,homeShowIndex) in homeShowData" style="margin-bottom: 16px;">
      <a-card :hoverable="true" :bordered="false"
              style="border-radius: 10px;" :style="{background: randomColor()}" >
        <div v-if="homeShowItem.img" style="margin-bottom: 10px;" v-html="homeShowItem.img" ></div>
        <a-statistic
          :title="homeShowItem.name"
          :value="homeShowItem.data"
          :precision="homeShowItem.precision?homeShowItem.precision:2"
          :suffix="homeShowItem.suffix"
          :value-style="{ color: homeShowItem.arrow?(homeShowItem.arrow==='up'?'#3f8600':'#cf1322'):'#1890ff' }"
        >
          <template #prefix v-if="homeShowItem.arrow">
            <a-icon :type="'arrow-'+homeShowItem.arrow" />
          </template>
        </a-statistic>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: "PanelCard",
  props:["homeShowData","showSpan"],
  methods:{
    randomColor(){
      return "rgba("+Math.floor(Math.random()*256)+","+Math.floor(Math.random()*256)+","+Math.floor(Math.random()*256)+",0.1)"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/PanelCard.vue